import React, { useEffect, useState } from 'react';

import { useHistory } from 'react-router-dom';
import { Stack } from '@fluentui/react/lib/Stack';
import { apiServices } from '../../services/ApiServices';
import { SearchBox, ISearchBoxStyles } from '@fluentui/react/lib/SearchBox';

import { IColumn } from '@fluentui/react/lib/DetailsList';
import { mergeStyleSets } from '@fluentui/react/lib/Styling';
import AccessibleComboBox from '../AccessibleComboBox';

import {
  getTheme,
  FontWeights,
  IIconProps,
  IComboBoxStyles,
  IDropdownOption,
  IComboBoxOption,
  ComboBox
} from '@fluentui/react';

export interface IButtonExampleProps {
  // These are set based on the toggles shown above the examples (not needed in real code)
  disabled?: boolean;
  checked?: boolean;
}
const theme = getTheme();
const searchBoxStyles: Partial<ISearchBoxStyles> = {
  root: { width: 210, height: "32px", right: '0xp', backgroundColor: '#F3F2F1', border: 'none' }
};
const classNames = mergeStyleSets({
  itemBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '48px',
    borderBottom: 'solid 1px #F3F2F1'
  },
  nameBox: {
    width: '30%',
    marginRight: '20px',
    boxSizing: 'border-box'
  },
  fileIconCell: {
    textAlign: 'center',
    selectors: {
      '&:before': {
        content: '.',
        display: 'inline-block',
        verticalAlign: 'middle',
        height: '100%',
        width: '0px',
        visibility: 'hidden'
      }
    }
  },
  fileIconImg: {
    verticalAlign: 'middle',
    maxHeight: '25px',
    maxWidth: '25px',
    borderRadius: '50%',
    marginRight: '10px'
  },
  controlWrapper: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  exampleToggle: {
    display: 'inline-block',
    marginBottom: '10px',
    marginRight: '30px'
  },
  selectionDetails: {
    marginBottom: '20px'
  },
  listButton: {
    fontWeight: '400',
    fontSize: '14px',
    background: '#FFFFFF',
    width: '96px',
    height: '32px',
    border: '1px solid #E1DFDD',
    borderRadius: '1px',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)'
  },
  DatePicker: {
    width: '110px',
    '.ms-TextField-fieldGroup': {
      border: 'none'
    }
  },
  container: {
    display: 'flex',
    width: '60%',
    minHeight: '100%',
    boxSizing: 'border-box',
    flexFlow: 'column nowrap',
    alignItems: 'stretch'
  },
  dialogModal: {
    alignItems: 'flex-start',
    boxSizing: 'border-box'
  },
  header: {
    flex: '1 1 auto',
    borderTop: `4px solid ${theme.palette.themePrimary}`,
    color: theme.palette.neutralPrimary,
    display: 'flex',
    alignItems: 'center',
    fontWeight: FontWeights.semibold,
    padding: '12px 12px 14px 24px'
  },
  body: {
    flex: '4 4 auto',
    padding: '0 24px 24px 24px',
    overflowY: 'scroll',
    selectors: {
      p: { margin: '14px 0' },
      'p:last-child': { marginBottom: 0 }
    },
    maxWidth: '100%',
    maxHeight: '100%',
    boxSizing: 'border-box'
  },
  Chat: {
    maxWidth: '100%',
    maxHeight: '100%',
    boxSizing: 'border-box',
    overflow: 'scroll'
  }
});
const cancelIcon: IIconProps = { iconName: 'Cancel' };
export interface IDetailsListDocumentsExampleState {
  columns: IColumn[];
  items: IDocument[];
  selectionDetails: string;
  isModalSelection: boolean;
  false: boolean;
  announcedMessage?: string;
}

export interface activeItemCreator {
  accessToken: any;
  channelUserId: string;
  displayName: string;
  tokenExpireOn: string;
  userAvatar: string;
  userId: string;
}
export interface activeItem {
  comment: string;
  createAt: string;
  creator: activeItemCreator;
  csrUser: any;
  displayTicketId: string;
  fromChannel: string;
  id: string;
  lastModifiedBy: any;
  status: number;
  tenantId: string;
  toChannel: string;
  updateAt: string;
  chatTime?: any;
}
export interface listAgent {
  comment: string;
  createAt: string;
  creator: activeItemCreator;
  csrUser: any;
  displayTicketId: string;
  fromChannel: string;
  id: string;
  lastModifiedBy: any;
  status: number;
  tenantId: string;
  toChannel: string;
  updateAt: string;
  chatTime?: any;
}
export interface IDocument {
  key: string;
  name: string;
  value: string;
  iconName: string;
  fileType: string;
  modifiedBy: string;
  dateModified: string;
  dateModifiedValue: number;
  fileSize: string;
  fileSizeRaw: number;
}
const basicStyles: Partial<IComboBoxStyles> = {
  root: { border: 'none', width: '100%', backgroundColor: '#F3F2F1' },
  container: { width: '50%', marginRight: '20px', border: 'none' },
  optionsContainer: { width: '100%', border: 'none' },
  input: { width: '100%', backgroundColor: '#F3F2F1', border: 'none' },
  callout: { width: '300px', border: 'none' }
};

export default function SetupPage() {
  //遮罩层 查看历史记录
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [listAgent, setListAgent] = useState<listAgent[]>();
  const [orglistAgent, setOrglistAgent] = useState<listAgent[]>();
  const [maxChatNumberList, setMaxChatNumberList] = useState<IComboBoxOption[]>([
    { key: '0', text: '0' },
    { key: '1', text: '1' },
    { key: '2', text: '2' },
    { key: '3', text: '3' },
    { key: '4', text: '4' }
  ]);
  const [activeItem, setActiveItem] = useState<activeItem>();

  useEffect(() => {
    getLogList();
  }, []);
  const ComboBoxChange = async (option: any, item: any, index: number) => {
    if (item) {
      let res = await apiServices.maxChatNumber(item.userId, option.key);
      if (res) {
        setListAgent((s: any) => {
          let newData = JSON.parse(JSON.stringify(s));
          newData[index].msg = {
            text: '修改成功',
            color: 'green'
          };
          return newData;
        });
      } else {
        setListAgent((s: any) => {
          let newData = JSON.parse(JSON.stringify(s));
          newData[index].msg = {
            text: '修改失败',
            color: 'red'
          };
          return newData;
        });
      }
    }
  };
  //列表
  const getLogList = async () => {
    let res = await apiServices.listAgent();
    setListAgent(res);
    setOrglistAgent(res);
  };

  // 搜索
  const SearchDisplayName = (name: any) => {
    if (name) {
      setListAgent((s: any) => {
        let newData = s.filter((item: any, index: number) => {
          return item.displayName.indexOf(name) != -1;
        });
        return newData;
      });
    } else {
      setListAgent(orglistAgent);
    }
  };

  return (
    <Stack style={{ width: '92%', display: 'felx', position: 'absolute', boxSizing: 'border-box' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', padding: '15px 0px' }}>
        {' '}
        <SearchBox
          styles={searchBoxStyles}
          placeholder="搜索客服姓名"
          onEscape={(ev) => {
            console.log('Custom onEscape Called');
          }}
          onClear={(ev) => {
            console.log('Custom onClear Called');
          }}
          onChange={(_, newValue) => {
            SearchDisplayName(newValue);
          }}
          onSearch={(newValue) => {
            SearchDisplayName(newValue);
          }}
        />{' '}
      </div>
      <div className={classNames.itemBox}>
        <div className={classNames.nameBox}>
          {' '}
          <span>客服姓名</span>{' '}
        </div>
        <div className={classNames.nameBox}>
          {' '}
          <span>最多接单数</span>{' '}
        </div>

        <div className={classNames.nameBox}>
          {' '}
          <span></span>{' '}
        </div>
      </div>
      {listAgent &&
        listAgent.map((item: any, index: number) => {
          return (
            <div key={index} className={classNames.itemBox}>
              <div className={classNames.nameBox}>
                {' '}
                <span>{item.displayName}</span>{' '}
              </div>
              <AccessibleComboBox
                id= {"setUpPage-accessible-comboBox" + index}
                defaultSelectedKey={item.maxChatNumber + ''}
                allowFreeform
                title='conservator'
                useComboBoxAsMenuWidth={true}
                autoComplete="on"
                options={maxChatNumberList}
                styles={basicStyles}
                onChange={(e, option) => {
                  ComboBoxChange(option, item, index);
                }}
                component={ComboBox}
              />
              <div style={{ width: '20%' }}>
                {' '}
                {item?.msg && <span style={{ color: item?.msg.color }}>{item?.msg.text}</span>}{' '}
              </div>
            </div>
          );
        })}
    </Stack>
  );
}
